import React from "react"

import DefaultLayout from "../layouts/default"
import TwoThirdsGrid from "../components/layout/TwoThirdsGrid"
import Text from "../components/text/Text"
import HeadlineWithSub from "../components/text/HeadlineWithSub"

const active = {
  title: "AGBs"
}

const AGBs = () => 
<DefaultLayout image="/assets/images/IMG_8128.jpeg" active={active}>
  <TwoThirdsGrid textRight>
    <div>
      <HeadlineWithSub>
        <h1>AGB</h1>
      </HeadlineWithSub>
    </div>
    <Text>
      <p>
        <strong>1. Geltungsbereich</strong><br />
        Diese AGB gelten <br />

        a) für sämtliche Weiterbildungen und Workshops, die von strichpunkt, Appenzell organisiert sind <br />
        b) für sämtliche Termine, die mit strichpunkt, Appenzell vereinbart wurden. Mit der Anmeldung zu einer Weiterbildung bzw. zu einem Workshop oder einem Termin erkennt der Teilnehmende oder der/die Klientin die Geschäftsbedingungen an.

      </p>
      
      <p>
       <strong>2. Anmeldung</strong><br />
        a) Weiterbildungs-/Workshopanmeldungen sind verbindlich. Mit der Zusendung der Anmeldebestätigung und der Rechnung gilt der Vertrag über die Teilnahme als abgeschlossen. Ihre Anmeldung wird in der Reihenfolge des Eingangs berücksichtigt. <br />
        Im Falle der Überbuchung wird die Anmeldende schnellstmöglich informiert; ein Vertrag kommt in diesem Fall nicht zustande. Nur vor Weiterbildungs-/Workshopbeginn eingegangene Zahlungen berechtigen zur Teilnahme. <br />
        b) Die Termine werden in gegenseitiger Absprache festgelegt und sind beidseitig verbindlich.
      </p>
      <p>
        <strong>3. Stornierung</strong><br />
        a) Weiterbildungs-/Workshopabmeldungen müssen schriftlich bis 14 Tage vor Beginn der Weiterbildung bzw. des Workshops erfolgen. Bei einer Abmeldung bis zu 7 Tage vor Weiterbildungs-/Workshopbeginn fallen Fr. 30.— Bearbeitungsgebühr an. Bis 3 Tage vor Beginn fallen 50 % der Weiterbildungs-/Workshopkosten an. Bei Abmeldungen später als 3 Tage vor Beginn werden die vollen Weiterbildungs-/Workshopkosten verrechnet. <br />
        In jedem Fall kann ein Ersatzteilnehmer gestellt werden, so dass lediglich eine Bearbeitungsgebühr von Fr. 30.-- entstehen. Es besteht kein Anspruch auf Ersatz eines versäumten Veranstaltungstages. <br />
        b) Termine: Im Verhinderungsfall muss der Termin mindestens 24h vor dem vereinbarten Zeitpunkt telefonisch oder schriftlich abgesagt werden. Für verspätete Abmeldungen wird ein Stundenhonorar in Rechnung gestellt.
      </p>
      <p>
        <strong>4. Absage durch strichpunkt</strong><br />
        a) Sollte eine Weiterbildung oder ein Workshop aus wichtigen Gründen seitens von strichpunkt abgesagt werden müssen, so besteht Anspruch auf volle Rückerstattung der Teilnahmegebühr. Ansprüche darüber hinaus bestehen nicht. <br />
        b) Im Verhinderungsfall aus wichtigen Gründen behält sich strichpunkt vor, einen Termin abzusagen. Es wird dabei ein Ersatztermin angeboten.
      </p>
      <p>
        <strong>5. Vertraulichkeit</strong><br />
        a) Für Weiterbildungs-/Workshopleitende sowie für Teilnehmer:innen gilt die Schweigepflicht über Kenntnisse, die über andere Personen, insbesondere Teilnehmende, in Erfahrung gebracht wurden, zu bewahren. <br />
        b) Alle Beratungs-, Supervisions- und Therapiegespräche werden vertraulich behandelt. Informationen an Krankenkassen, Ärztinnen, etc. werden nur im Einverständnis der Klient:innen gegeben.
      </p>
      <p>
        <strong>6. Haftungsausschluss</strong><br />
        Jeder Teilnehmer, jede Teilnehmerin trägt die volle Verantwortung für sich und seine/ihre Handlungen inner- und außerhalb der Weiterbildungs-/Workshopgruppe und der Beratungs-, Supervisions- und Therapietermine und kommt für verursachte Schäden selbst auf. Sämtliche Versicherungen (Krankheit, Unfall, Haftpflicht, Annullation) sind Sache der Teilnehmer:innen, Supervisand:innen und Klient:innen.
      </p>
      <p>
        <strong>7. Änderungsvorbehalte</strong><br />
        strichpunkt ist berechtigt, notwendige inhaltliche, methodische und organisatorische Änderungen oder Abweichungen vor oder während der Weiterbildungen und Workshops vorzunehmen, soweit diese den Nutzen der angekündigten Veranstaltung für die Teilnehmenden nicht wesentlich ändern
      </p>
      <p>
        <strong>8. Anwendbares Recht</strong><br />
        Zur Anwendung kommt ausschliesslich schweizerisches Recht. Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam oder ergänzungsbedürftig sein oder werden, so bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. Die Vertragspartner werden anstelle der unwirksamen oder ergänzungsbedürftigen Bestimmungen eine neue Regelung vereinbaren, die dem gewollten wirtschaftlichen Zweck am nächsten kommt.
      </p>
    </Text>
  </TwoThirdsGrid>
</DefaultLayout>

export default AGBs